import UserGroupFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => (
  <GenericCreateForm formLayoutComponent={<UserGroupFormLayout />} transformValues={transformValues} />
)
